import { render, staticRenderFns } from "./RegistryActionEntityFields.vue?vue&type=template&id=0e5754b4"
import script from "./RegistryActionEntityFields.vue?vue&type=script&lang=js"
export * from "./RegistryActionEntityFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e5754b4')) {
      api.createRecord('0e5754b4', component.options)
    } else {
      api.reload('0e5754b4', component.options)
    }
    module.hot.accept("./RegistryActionEntityFields.vue?vue&type=template&id=0e5754b4", function () {
      api.rerender('0e5754b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/registry/RegistryActionEntityFields.vue"
export default component.exports